import { render, staticRenderFns } from "./EstatisticaAcesso.vue?vue&type=template&id=318e2dd6&"
import script from "./EstatisticaAcesso.vue?vue&type=script&lang=js&"
export * from "./EstatisticaAcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports